import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import H2Font from "Root/profile/components/common/H2Font";
import LargeFont from "Root/profile/components/common/LargeFont";
import styles from "./styles.module.scss";
const PLPSectionWrapper = ({ title, subtitle, children }) => {
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx(H2Font, { fontWeight: 400, children: title }), subtitle && _jsx(LargeFont, { children: subtitle }), children] }));
};
export default PLPSectionWrapper;
